import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getHoursAndMin } from "utils/CommonFunctions";
import StatsItem from "./statsItem";

const PlanItem = (props: any) => {
  const { plan, listId } = props;
  const navigate = useNavigate();
  const { list } = useAppSelector((state) => state.functionalAreas);
  const { myListDetails } = useAppSelector((state) => state.sme);
  // @ts-ignore
  const fnArea = list.filter((l: any) => plan?.functionalAreaIds?.some((f: any) => l.id === f));
  const assignees =
    // @ts-ignore
    myListDetails?.planAssigneeMap.filter((p: any) => p.cmsPlanId === plan.id)[0]?.assignedInnCodeGroupMappingCount;

  const handleNavigateToPlanStats = () => {
    navigate(`/planstats/${plan.id}/${listId}`);
  };

  return (
    <Box
      sx={{
        marginX: "24px",
        paddingY: "24px",
        borderBottom: `1px solid ${tokens.Border.General.Tertiary}`,
        "&:last-child": { borderBottom: "none" }
      }}
    >
      <Stack direction="row" alignItems="flex-start" sx={{ marginBottom: "18px" }}>
        <Typography variant="body1" showBold color={tokens.Text.General.PrimaryHeadline} sx={{ flex: 1 }}>
          {plan.name}
        </Typography>
        <Stack direction="row" alignItems="center" justifyContent="flex-end">
          <Timing color={tokens.Text.General.Secondary} duration={getHoursAndMin(plan.timeEstimateMinutes)} />
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center">
        <Box flex={1}>
          <Typography
            variant="label"
            color={tokens.Text.General.Secondary}
            sx={{
              textTransform: "capitalize",
              marginRight: "8px",
              fontSize: "12px"
            }}
          >
            {fnArea.map((fn: any, index: number) => (
              <>
                {" "}
                {fn.name}
                {fnArea.length - 1 === index ? "" : ","}
              </>
            ))}
            &nbsp; &bull; {assignees} Assignees
          </Typography>
        </Box>
        <Button variant="outlined" label="Plan Details" onClick={handleNavigateToPlanStats} />
      </Stack>
    </Box>
  );
};

const PlanTab = (props: any) => {
  const { myListDetails, status, plans } = useAppSelector((state) => state.sme);
  const { isMobileScreen } = useContext(ThemeContext);

  return (
    <>
      <Box
        sx={{
          padding: "20px 24px 32px 24px",
          borderBottom: `1px solid ${tokens.Border.General.Tertiary}`,
          backgroundColor: tokens.Background.General.Primary
        }}
      >
        {isMobileScreen && (
          <Typography
            variant="body2"
            showBold
            color={tokens.Text.General.Secondary}
            sx={{
              marginTop: "24px",
              marginBottom: "4px"
            }}
          >
            Plans
          </Typography>
        )}
        <Grid
          container
          alignItems="center"
          sx={{
            backgroundColor: tokens.Background.General.Secondary,
            paddingY: "12px",
            borderRadius: "12px"
          }}
        >
          {isMobileScreen ? (
            <>
              <StatsItem title="Inncodes" data={myListDetails.innCodeGroupMappingCount || 0} />
              <StatsItem title="Plan Assignments" data={myListDetails.assignedPlanCount || 0} />
            </>
          ) : (
            <>
              <StatsItem title="Inncodes" data={myListDetails.innCodeGroupMappingCount || 0} />
              <StatsItem title="Plan Assignments" data={myListDetails.assignedPlanCount || 0} />
              <StatsItem title="Plans w/ overdue Actions" data={myListDetails.overDueCardPlansCount || 0} />
              <StatsItem title="Plans w/ unassigned Actions" data={myListDetails.unAssignedCardPlansCount || 0} />
            </>
          )}
        </Grid>
        {isMobileScreen && (
          <>
            <Typography
              variant="body2"
              showBold
              color={tokens.Text.General.Secondary}
              sx={{
                marginTop: "8px",
                marginBottom: "4px"
              }}
            >
              Engagement
            </Typography>
            <Grid
              container
              alignItems="center"
              sx={{
                backgroundColor: tokens.Background.General.Secondary,
                paddingY: "12px",
                borderRadius: "12px"
              }}
            >
              <StatsItem title="Plans w/ overdue Actions" data={myListDetails.overDueCardPlansCount || 0} />
              <StatsItem title="Plans w/ unassigned Actions" data={myListDetails.unAssignedCardPlansCount || 0} />
            </Grid>
          </>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: tokens.Background.General.Primary
        }}
      >
        {status === "loading" ? (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              height: "100%"
            }}
          >
            Loading...
          </Stack>
        ) : (
          myListDetails?.planAssigneeMap?.length &&
          plans?.map((plan: any) => <PlanItem key={plan.cmsPlanId} plan={plan} listId={props.selectedListId} />)
        )}
      </Box>
    </>
  );
};

export default PlanTab;
